import React, { useState } from 'react';

function DataSources({ showToast }) {
  const [showModal, setShowModal] = useState(false);
  const [editingSource, setEditingSource] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [showStructureModal, setShowStructureModal] = useState(false);
  const [selectedStructure, setSelectedStructure] = useState(null);
  const [viewMode, setViewMode] = useState('grid'); // 'grid', 'list', 'table'

  const [dataSources, setDataSources] = useState([
    {
      id: 1,
      code: 'CORE_BANKING',
      name: 'Core Banking System',
      type: 'database',
      dbType: 'Oracle',
      host: '10.10.10.100',
      port: 1521,
      database: 'COREDB',
      username: 'core_user',
      tableCount: 150,
      status: 'Kết nối',
      lastSync: '28/05/2026 08:00',
      createdDate: '01/01/2024'
    },
    {
      id: 2,
      code: 'CIC_DATA',
      name: 'Dữ liệu CIC',
      type: 'csv',
      fileCount: 5,
      tableCount: 5,
      totalSize: '250 MB',
      status: 'Hoạt động',
      lastSync: '27/05/2026 23:00',
      createdDate: '15/02/2024'
    },
    {
      id: 3,
      code: 'CUSTOMER_EXCEL',
      name: 'Báo cáo khách hàng',
      type: 'excel',
      fileName: 'KhachHang_2026.xlsx',
      sheetCount: 8,
      tableCount: 8,
      totalSize: '45 MB',
      status: 'Hoạt động',
      lastSync: '28/05/2026 06:00',
      createdDate: '20/03/2024'
    },
    {
      id: 4,
      code: 'CREDIT_DB',
      name: 'Hệ thống tín dụng',
      type: 'database',
      dbType: 'PostgreSQL',
      host: '10.10.10.101',
      port: 5432,
      database: 'credit_db',
      username: 'credit_app',
      tableCount: 85,
      status: 'Kết nối',
      lastSync: '28/05/2026 08:15',
      createdDate: '10/04/2024'
    }
  ]);

  const [formData, setFormData] = useState({
    code: '',
    name: '',
    type: 'csv',
    // For CSV
    files: [],
    // For Excel
    excelFile: null,
    // For Database
    dbType: 'Oracle',
    host: '',
    port: '',
    database: '',
    username: '',
    password: '',
    schema: '',
    status: 'Hoạt động'
  });

  const filterDataSources = () => {
    return dataSources.filter(source => {
      const matchesSearch = source.name.toLowerCase().includes(searchText.toLowerCase()) ||
        source.code.toLowerCase().includes(searchText.toLowerCase());
      const matchesType = !typeFilter || source.type === typeFilter;
      return matchesSearch && matchesType;
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const openCreateModal = () => {
    setEditingSource(null);
    setFormData({
      code: '',
      name: '',
      type: 'csv',
      files: [],
      excelFile: null,
      dbType: 'Oracle',
      host: '',
      port: '',
      database: '',
      username: '',
      password: '',
      schema: '',
      status: 'Hoạt động'
    });
    setShowModal(true);
  };

  const openEditModal = (source) => {
    setEditingSource(source);
    setFormData({
      code: source.code,
      name: source.name,
      type: source.type,
      dbType: source.dbType || 'Oracle',
      host: source.host || '',
      port: source.port || '',
      database: source.database || '',
      username: source.username || '',
      password: '',
      schema: source.schema || '',
      status: source.status,
      files: [],
      excelFile: null
    });
    setShowModal(true);
  };

  const handleSaveDataSource = (e) => {
    e.preventDefault();
    
    if (editingSource) {
      setDataSources(dataSources.map(source =>
        source.id === editingSource.id
          ? { ...source, ...formData, lastSync: new Date().toLocaleString('vi-VN') }
          : source
      ));
      showToast('Cập nhật nguồn dữ liệu thành công', 'success');
    } else {
      const newSource = {
        id: Math.max(...dataSources.map(s => s.id), 0) + 1,
        ...formData,
        tableCount: formData.type === 'csv' ? formData.files.length : 
                    formData.type === 'excel' ? 0 : 0,
        lastSync: 'Chưa đồng bộ',
        createdDate: new Date().toLocaleDateString('vi-VN')
      };
      setDataSources([...dataSources, newSource]);
      showToast('Thêm nguồn dữ liệu mới thành công', 'success');
    }
    
    setShowModal(false);
  };

  const deleteDataSource = (id) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa nguồn dữ liệu này?')) {
      setDataSources(dataSources.filter(source => source.id !== id));
      showToast('Xóa nguồn dữ liệu thành công', 'success');
    }
  };

  const syncDataSource = (id) => {
    // Giả lập việc đồng bộ và refresh structure
    setDataSources(dataSources.map(source =>
      source.id === id
        ? { ...source, lastSync: new Date().toLocaleString('vi-VN'), status: 'Kết nối' }
        : source
    ));
    showToast('Đồng bộ cấu trúc dữ liệu thành công', 'success');
  };

  const viewStructure = (source) => {
    // Mock structure data - trong thực tế sẽ lấy từ API/Database
    const mockStructure = {
      CORE_BANKING: {
        tables: [
          { 
            name: 'loans', 
            displayName: 'Loans',
            rowCount: 15420,
            columns: [
              { name: 'loan_id', type: 'number', nullable: false, description: 'Mã khoản vay' },
              { name: 'amount', type: 'number', nullable: false, description: 'Số tiền vay' },
              { name: 'overdue_amount', type: 'number', nullable: true, description: 'Số tiền quá hạn' },
              { name: 'overdue_days', type: 'number', nullable: true, description: 'Số ngày quá hạn' },
              { name: 'customer_id', type: 'text', nullable: false, description: 'Mã khách hàng' },
              { name: 'status', type: 'text', nullable: false, description: 'Trạng thái' },
              { name: 'created_date', type: 'date', nullable: false, description: 'Ngày tạo' },
              { name: 'is_active', type: 'boolean', nullable: false, description: 'Còn hoạt động' }
            ]
          },
          { 
            name: 'customers', 
            displayName: 'Customers',
            rowCount: 8930,
            columns: [
              { name: 'customer_id', type: 'text', nullable: false, description: 'Mã khách hàng' },
              { name: 'name', type: 'text', nullable: false, description: 'Tên khách hàng' },
              { name: 'income', type: 'number', nullable: true, description: 'Thu nhập' },
              { name: 'risk_score', type: 'number', nullable: true, description: 'Điểm rủi ro' },
              { name: 'registration_date', type: 'date', nullable: false, description: 'Ngày đăng ký' },
              { name: 'is_vip', type: 'boolean', nullable: false, description: 'KH VIP' }
            ]
          }
        ]
      },
      CIC_DATA: {
        tables: [
          { 
            name: 'credit_score', 
            displayName: 'Credit Score',
            rowCount: 8500,
            columns: [
              { name: 'customer_id', type: 'text', nullable: false, description: 'Mã khách hàng' },
              { name: 'score', type: 'number', nullable: false, description: 'Điểm tín dụng' },
              { name: 'rank', type: 'text', nullable: false, description: 'Xếp hạng' },
              { name: 'last_update', type: 'date', nullable: false, description: 'Cập nhật lần cuối' },
              { name: 'has_bad_debt', type: 'boolean', nullable: false, description: 'Có nợ xấu' }
            ]
          }
        ]
      },
      CUSTOMER_EXCEL: {
        tables: [
          { 
            name: 'Sheet1', 
            displayName: 'Thông tin khách hàng',
            rowCount: 2340,
            columns: [
              { name: 'ma_kh', type: 'text', nullable: false, description: 'Mã khách hàng' },
              { name: 'ten_kh', type: 'text', nullable: false, description: 'Tên' },
              { name: 'so_du', type: 'number', nullable: true, description: 'Số dư' },
              { name: 'ngay_mo', type: 'date', nullable: false, description: 'Ngày mở TK' }
            ]
          }
        ]
      },
      CREDIT_DB: {
        tables: [
          { 
            name: 'applications', 
            displayName: 'Credit Applications',
            rowCount: 12800,
            columns: [
              { name: 'app_id', type: 'text', nullable: false, description: 'Mã hồ sơ' },
              { name: 'customer_id', type: 'text', nullable: false, description: 'Mã KH' },
              { name: 'amount_requested', type: 'number', nullable: false, description: 'Số tiền đề nghị' },
              { name: 'approved', type: 'boolean', nullable: false, description: 'Đã duyệt' },
              { name: 'application_date', type: 'date', nullable: false, description: 'Ngày nộp' }
            ]
          }
        ]
      }
    };

    setSelectedStructure({
      ...source,
      structure: mockStructure[source.code] || { tables: [] }
    });
    setShowStructureModal(true);
  };

  const getTypeLabel = (type) => {
    const labels = {
      'csv': 'CSV Files',
      'excel': 'Excel File',
      'database': 'Database'
    };
    return labels[type] || type;
  };

  const getTypeBadgeClass = (type) => {
    const classes = {
      'csv': 'success',
      'excel': 'info',
      'database': 'primary'
    };
    return classes[type] || 'secondary';
  };

  const getStatusBadgeClass = (status) => {
    return status === 'Kết nối' || status === 'Hoạt động' ? 'success' : 'warning';
  };

  const filteredDataSources = filterDataSources();

  return (
    <div className="container-fluid">
      {/* Header */}
      <div className="page-header-sticky">
        <div>
          <h2 className="mb-1">
            <i className="bi bi-database me-2"></i>
            Quản lý Nguồn dữ liệu
          </h2>
          <p className="text-muted mb-0">Quản lý các nguồn dữ liệu cho hệ thống cảnh báo sớm</p>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="row mb-4">
        <div className="col-md-3">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Tổng nguồn</h6>
                  <h3 className="mb-0">{dataSources.length}</h3>
                </div>
                <div className="text-primary">
                  <i className="bi bi-database fs-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Database</h6>
                  <h3 className="mb-0 text-primary">{dataSources.filter(s => s.type === 'database').length}</h3>
                </div>
                <div className="text-primary">
                  <i className="bi bi-server fs-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">CSV/Excel</h6>
                  <h3 className="mb-0 text-success">{dataSources.filter(s => s.type === 'csv' || s.type === 'excel').length}</h3>
                </div>
                <div className="text-success">
                  <i className="bi bi-file-earmark-spreadsheet fs-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="text-muted mb-1">Tổng bảng</h6>
                  <h3 className="mb-0 text-info">{dataSources.reduce((sum, s) => sum + (s.tableCount || 0), 0)}</h3>
                </div>
                <div className="text-info">
                  <i className="bi bi-table fs-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filters and Actions */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-5">
              <label className="form-label">Tìm kiếm</label>
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Tìm theo tên, mã nguồn..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label">Loại nguồn</label>
              <select 
                className="form-select"
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
              >
                <option value="">Tất cả loại</option>
                <option value="database">Database</option>
                <option value="csv">CSV Files</option>
                <option value="excel">Excel File</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label">Hiển thị</label>
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('grid')}
                  title="Xem dạng lưới"
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('list')}
                  title="Xem dạng danh sách"
                >
                  <i className="bi bi-list-ul"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('table')}
                  title="Xem dạng bảng"
                >
                  <i className="bi bi-table"></i>
                </button>
              </div>
            </div>
            <div className="col-md-2 text-end">
              <label className="form-label">&nbsp;</label>
              <button 
                className="btn btn-primary w-100"
                onClick={openCreateModal}
              >
                <i className="bi bi-plus-circle me-2"></i>
                Thêm
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Data Sources Table */}
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Mã nguồn</th>
                  <th>Tên nguồn dữ liệu</th>
                  <th>Loại</th>
                  <th>Thông tin</th>
                  <th className="text-center">Số bảng</th>
                  <th>Đồng bộ lần cuối</th>
                  <th className="text-center">Trạng thái</th>
                  <th className="text-center">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {filteredDataSources.length > 0 ? (
                  filteredDataSources.map(source => (
                    <tr key={source.id}>
                      <td>
                        <span className="badge bg-secondary">{source.code}</span>
                      </td>
                      <td>
                        <strong>{source.name}</strong>
                      </td>
                      <td>
                        <span className={`badge bg-${getTypeBadgeClass(source.type)}`}>
                          {getTypeLabel(source.type)}
                        </span>
                      </td>
                      <td>
                        {source.type === 'database' && (
                          <small className="text-muted">
                            <i className="bi bi-server me-1"></i>
                            {source.dbType} - {source.host}:{source.port}
                          </small>
                        )}
                        {source.type === 'csv' && (
                          <small className="text-muted">
                            <i className="bi bi-file-earmark-text me-1"></i>
                            {source.fileCount} files - {source.totalSize}
                          </small>
                        )}
                        {source.type === 'excel' && (
                          <small className="text-muted">
                            <i className="bi bi-file-earmark-excel me-1"></i>
                            {source.sheetCount} sheets - {source.totalSize}
                          </small>
                        )}
                      </td>
                      <td className="text-center">
                        <span className="badge bg-info">{source.tableCount}</span>
                      </td>
                      <td>
                        <small>{source.lastSync}</small>
                      </td>
                      <td className="text-center">
                        <span className={`badge bg-${getStatusBadgeClass(source.status)}`}>
                          {source.status}
                        </span>
                      </td>
                      <td className="text-center">
                        <button 
                          className="btn btn-sm btn-outline-success me-1"
                          onClick={() => syncDataSource(source.id)}
                          title="Đồng bộ"
                        >
                          <i className="bi bi-arrow-repeat"></i>
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-info me-1"
                          onClick={() => viewStructure(source)}
                          title="Xem cấu trúc"
                        >
                          <i className="bi bi-diagram-3"></i>
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => openEditModal(source)}
                          title="Chỉnh sửa"
                        >
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => deleteDataSource(source.id)}
                          title="Xóa"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center text-muted py-4">
                      <i className="bi bi-inbox fs-1"></i>
                      <p className="mt-2">Không tìm thấy nguồn dữ liệu nào</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingSource ? 'Chỉnh sửa nguồn dữ liệu' : 'Thêm nguồn dữ liệu mới'}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleSaveDataSource}>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Mã nguồn <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="code"
                        className="form-control"
                        value={formData.code}
                        onChange={handleInputChange}
                        placeholder="VD: CORE_BANKING"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Tên nguồn dữ liệu <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="VD: Core Banking System"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Loại nguồn <span className="text-danger">*</span></label>
                      <select
                        name="type"
                        className="form-select"
                        value={formData.type}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="csv">CSV Files (Multiple)</option>
                        <option value="excel">Excel File (Multiple Sheets)</option>
                        <option value="database">Database Connection</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Trạng thái</label>
                      <select
                        name="status"
                        className="form-select"
                        value={formData.status}
                        onChange={handleInputChange}
                      >
                        <option value="Hoạt động">Hoạt động</option>
                        <option value="Tạm dừng">Tạm dừng</option>
                      </select>
                    </div>

                    {/* CSV Upload */}
                    {formData.type === 'csv' && (
                      <div className="col-12">
                        <label className="form-label">Upload CSV Files</label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".csv"
                          multiple
                          onChange={(e) => setFormData(prev => ({ ...prev, files: Array.from(e.target.files) }))}
                        />
                        <small className="text-muted">Chọn nhiều file CSV, mỗi file sẽ tạo thành 1 bảng</small>
                      </div>
                    )}

                    {/* Excel Upload */}
                    {formData.type === 'excel' && (
                      <div className="col-12">
                        <label className="form-label">Upload Excel File</label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".xlsx,.xls"
                          onChange={(e) => setFormData(prev => ({ ...prev, excelFile: e.target.files[0] }))}
                        />
                        <small className="text-muted">Mỗi sheet trong file Excel sẽ tạo thành 1 bảng</small>
                      </div>
                    )}

                    {/* Database Connection */}
                    {formData.type === 'database' && (
                      <>
                        <div className="col-md-6">
                          <label className="form-label">Loại Database <span className="text-danger">*</span></label>
                          <select
                            name="dbType"
                            className="form-select"
                            value={formData.dbType}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="Oracle">Oracle</option>
                            <option value="MySQL">MySQL</option>
                            <option value="PostgreSQL">PostgreSQL</option>
                            <option value="SQLServer">SQL Server</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Host <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            name="host"
                            className="form-control"
                            value={formData.host}
                            onChange={handleInputChange}
                            placeholder="VD: 10.10.10.100"
                            required
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Port <span className="text-danger">*</span></label>
                          <input
                            type="number"
                            name="port"
                            className="form-control"
                            value={formData.port}
                            onChange={handleInputChange}
                            placeholder="VD: 1521"
                            required
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Database <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            name="database"
                            className="form-control"
                            value={formData.database}
                            onChange={handleInputChange}
                            placeholder="VD: COREDB"
                            required
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Schema</label>
                          <input
                            type="text"
                            name="schema"
                            className="form-control"
                            value={formData.schema}
                            onChange={handleInputChange}
                            placeholder="VD: dbo"
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Username <span className="text-danger">*</span></label>
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            value={formData.username}
                            onChange={handleInputChange}
                            placeholder="Database username"
                            required
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Password <span className="text-danger">*</span></label>
                          <input
                            type="password"
                            name="password"
                            className="form-control"
                            value={formData.password}
                            onChange={handleInputChange}
                            placeholder="Database password"
                            required={!editingSource}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-secondary" 
                    onClick={() => setShowModal(false)}
                  >
                    Hủy
                  </button>
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-check-circle me-2"></i>
                    {editingSource ? 'Cập nhật' : 'Thêm mới'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Structure Modal */}
      {showStructureModal && selectedStructure && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-diagram-3 me-2"></i>
                  Cấu trúc dữ liệu: {selectedStructure.name}
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setShowStructureModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="alert alert-info">
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Nguồn:</strong> {selectedStructure.code} | 
                  <strong className="ms-3">Loại:</strong> {getTypeLabel(selectedStructure.type)} |
                  <strong className="ms-3">Lần đồng bộ cuối:</strong> {selectedStructure.lastSync}
                </div>

                {selectedStructure.structure.tables.length > 0 ? (
                  selectedStructure.structure.tables.map((table, tIdx) => (
                    <div key={tIdx} className="card mb-3">
                      <div className="card-header bg-primary bg-opacity-10">
                        <h6 className="mb-0">
                          <i className="bi bi-table me-2"></i>
                          <strong>{table.displayName}</strong> 
                          <span className="text-muted ms-2">({table.name})</span>
                          <span className="badge bg-secondary ms-2">{table.rowCount.toLocaleString()} rows</span>
                        </h6>
                      </div>
                      <div className="card-body p-0">
                        <table className="table table-sm table-hover mb-0">
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: '25%' }}>Tên cột</th>
                              <th style={{ width: '15%' }}>Kiểu dữ liệu</th>
                              <th style={{ width: '10%' }}>Nullable</th>
                              <th style={{ width: '50%' }}>Mô tả</th>
                            </tr>
                          </thead>
                          <tbody>
                            {table.columns.map((col, cIdx) => (
                              <tr key={cIdx}>
                                <td>
                                  <code className="text-primary">{col.name}</code>
                                </td>
                                <td>
                                  <span className={`badge bg-${
                                    col.type === 'number' ? 'success' :
                                    col.type === 'text' ? 'info' :
                                    col.type === 'date' ? 'warning' :
                                    col.type === 'boolean' ? 'secondary' : 'dark'
                                  }`}>
                                    {col.type}
                                  </span>
                                </td>
                                <td>
                                  {col.nullable ? (
                                    <span className="text-success">
                                      <i className="bi bi-check-circle"></i> Yes
                                    </span>
                                  ) : (
                                    <span className="text-danger">
                                      <i className="bi bi-x-circle"></i> No
                                    </span>
                                  )}
                                </td>
                                <td className="text-muted">{col.description}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="alert alert-warning">
                    <i className="bi bi-exclamation-triangle me-2"></i>
                    Chưa có thông tin cấu trúc. Vui lòng đồng bộ dữ liệu.
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-success"
                  onClick={() => {
                    syncDataSource(selectedStructure.id);
                    showToast('Đang đồng bộ cấu trúc...', 'info');
                  }}
                >
                  <i className="bi bi-arrow-repeat me-2"></i>
                  Đồng bộ lại cấu trúc
                </button>
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setShowStructureModal(false)}
                >
                  Đóng
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DataSources;
